import { RampTypeBase } from './base/ramp-type-base';

export class RampType extends RampTypeBase { }